module.exports = __webpack_public_path__ + "img/logo.a165480.png";